import { excerpts } from './reviewData';

// 동일한 가상 면담의 화면 전용 데이터. 실제 분석 및 API와 연결하지 않습니다.
// 회기 당시 모듈 기준의 결과입니다.
export const sessionOutcome = { module: 'MI · 동기면담', congruent: true, goalScores: [1, 1, 0.5, 0] };
export const moments = [
    { ...excerpts[0], title: '두 마음을 함께 알아준 순간', response: '맞아요. 쉬고 싶은데, 이렇게 지내는 제가 싫기도 해요.', alternative: '쉬는 시간도 필요하고, 지금과는 달라지고 싶은 마음도 있으시군요.', reason: '양가감정을 함께 반영하면 한쪽을 설득하지 않고 이야기를 이어갈 수 있습니다.' },
    { ...excerpts[1], title: '해결책이 조금 앞섰던 순간', response: '매일이요? 못 지키면 또 제가 한심해질 것 같아요.', reason: '도움이 됐던 경험을 인정하고, 가능한 방법과 속도를 내담자가 선택하도록 돕습니다.', warm: true },
    { ...excerpts[3], title: '선택권을 돌려준 순간', response: '그럼 이번 주말에 한 번, 집 앞에만 나가볼게요.', alternative: '주말에 한 번 나가보는 것이 지금은 맞는 속도군요. 실행에 도움이 될 것은 무엇일까요?', reason: '내담자가 선택한 계획을 존중하면서 실행에 필요한 자원을 탐색합니다.' },
];
export const sessionFlow = [
    { stage: '초반', time: '04:32', rapport: 55, defense: 55, disclosure: '감정 표현 시작', note: '양가감정 반영 뒤, 쉬고 싶은 마음과 자기비판을 함께 말했습니다.' },
    { stage: '중반', time: '09:15', rapport: 40, defense: 70, disclosure: '실패 부담 표현', note: '매일 산책하자는 제안에, 지키지 못할 부담을 표현했습니다.' },
    { stage: '후반', time: '16:08', rapport: 65, defense: 40, disclosure: '실행 의사 표현', note: '선택권을 확인한 뒤, 주말에 한 번 시도할 계획을 말했습니다.' },
];
export const practiceReasons = ['12:40 · 변화의 이점을 묻는 질문을 다음 탐색으로 이어가기', '09:15 · 성급한 제안으로 생긴 부담 줄이기', '16:08 · 내담자의 선택을 실행 가능한 계획으로 연결하기'];

export const perspectiveDetails = {
    mi: {
        strength: '발언 근거 · “쉬고 싶은 마음도 있지만, 이 시간이 반복될까 봐 걱정되시는군요.”',
        growth: '“어떤 점이 좋아질까요?”라는 질문 뒤에, 그 변화가 왜 중요한지도 물어보세요.',
    },
    object: {
        strength: '발언 근거 · 실패를 걱정하는 마음을 반영하며 경험을 말할 여지를 남겼습니다.',
        growth: '비교가 일어난 구체적인 장면에서 자신과 상대를 어떻게 느꼈는지 확인해보세요.',
    },
    pbt: {
        strength: '발언 근거 · “예전에는 산책하면 좀 나았는데”라는 내담자의 경험을 포착했습니다.',
        growth: '“쉬고 있을 때와 그 이후에는 마음이 어떻게 달라지나요?”라고 물어보세요.',
    },
};
